import { Betalsparr } from "../Flode";
import { Ikon, type IkonNamn } from "../Ikon";
import { Shead } from "./Sektion";

const PUNKTER: [IkonNamn, string, string][] = [
  ["registry", "Agenten ändrar aldrig registret", "Nya bankuppgifter och org.nr blir förslag som ekonomi godkänner. Nya bankuppgifter kräver två personer."],
  ["log", "Allt loggas", "Varje beslut sparas med indata, källa, kontroller, säkerhet och agentversion."],
  ["eu", "I molnet, inom EU", "Allt lagras i en molntjänst med datacenter inom EU. Inget installeras hos er, och varje bolag ser bara sina egna uppgifter."],
];

// Exempel på en beslutspost: exakt de fält som texten säger loggas. [nyckel, värde, färgklass, indrag]
const POST: [string, string?, string?, boolean?][] = [
  ["faktura", "10482", "n2"],
  ["indata", "exempelfaktura_10482.pdf", "s"],
  ["källa", "e-post", "s"],
  ["kontroller"],
  ["leverantör", "ok", "s", true],
  ["moms", "ok", "s", true],
  ["dubblett", "ok", "s", true],
  ["referens", "osäker", "y", true],
  ["betalväg", "avviker från registret", "r", true],
  ["säkerhet", "0,97", "n2"],
  ["utfall", "röd · handläggning", "r"],
  ["agentversion", "x.y.z", "n2"],
];

function Beslutspost() {
  return (
    <div className="log" role="img" aria-label="Exempel på en beslutspost med indata, källa, kontroller, säkerhet och agentversion">
      <div className="lh" aria-hidden="true"><i /><i /><i /><span>BESLUTSPOST · EXEMPEL</span></div>
      <pre aria-hidden="true">
        {POST.map(([k, v, c, sub], i) => (
          <span key={k}>
            {i ? "\n" : ""}
            {sub ? "  " + k.padEnd(13) : <span className="k">{v ? k.padEnd(13) : k}</span>}
            {v ? <span className={c}>{v}</span> : null}
          </span>
        ))}
      </pre>
      <div className="note" aria-hidden="true">Illustration. Fälten visar vad som sparas, inte verkliga värden.</div>
    </div>
  );
}

export function Sakerhet() {
  return (
    <section className="s alt" id="sakerhet">
      <div className="wrap">
        <Shead eyebrow="Säkerhet" rubrik="Agenten föreslår. Människor bestämmer." />
        <div className="sec">
          <div className="sitems">
            {PUNKTER.map(([ikon, h, p]) => (
              <div key={h} className="sitem"><span className="ico"><Ikon namn={ikon} /></span><div><h3>{h}</h3><p>{p}</p></div></div>
            ))}
          </div>
          <Beslutspost />
        </div>

        <div className="pay" id="betalvag">
          <div className="t">
            <span className="eyebrow">Betalvägen</span>
            <h3 className="h3">Betalningen spärras, inte attesten</h3>
            <p className="lead">Saknas betalvägen i registret konteras och attesteras fakturan som vanligt. Den betalas först när ekonomi har verifierat betalvägen via en kontaktväg ni redan känner till.</p>
            <div className="stop">
              <div className="hd"><Ikon namn="lock" />Stoppas alltid</div>
              <ul>
                <li>En annan betalväg än den registrerade</li>
                <li>Meddelanden om nya bankuppgifter</li>
              </ul>
              <p>Det är de vanligaste tecknen på fakturabedrägeri.</p>
            </div>
          </div>
          <Betalsparr kort />
        </div>
      </div>
    </section>
  );
}
